import { PntStationStatusItemDtoV2 } from '@mi-front/core';
import { Dialog, DialogContent, Stack } from '@mui/material';
import { ScheduleStatusSpotDetailSchedules } from '../spot/ScheduleStatusSpotDetailSchedules';
import { hasPossibleUnmatchedMentionsMatches } from './schedule-status-mentions-utils';
import { ScheduleStatusMentionsDetailContent } from './ScheduleStatusMentionsDetailContent';
import { ScheduleStatusMentionsDetailHeader } from './ScheduleStatusMentionsDetailHeader';
import { ScheduleStatusMentionsDetailMetadata } from './ScheduleStatusMentionsDetailMetadata';
import { ScheduleStatusMentionsDetailUnmatchedMatches } from './ScheduleStatusMentionsDetailUnmatchedMatches';

/**
 * Detail dialog for a mention: coverage, metadata, script, slot schedules, extra detections.
 */
export function ScheduleStatusMentionsDetailDialog(p: {
  item: PntStationStatusItemDtoV2 | null;
  onHide: () => void;
}) {
  if (!p.item) {
    return null;
  }

  return (
    <Dialog open={!!p.item} onClose={p.onHide} maxWidth="md" fullWidth scroll="paper">
      <ScheduleStatusMentionsDetailHeader item={p.item} onHide={p.onHide} />
      <DialogContent dividers>
        <Stack spacing={3}>
          <ScheduleStatusMentionsDetailMetadata item={p.item} />
          <ScheduleStatusMentionsDetailContent item={p.item} />
          <ScheduleStatusSpotDetailSchedules schedules={p.item.schedules ?? []} />
          {hasPossibleUnmatchedMentionsMatches(p.item) && (
            <ScheduleStatusMentionsDetailUnmatchedMatches item={p.item} />
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
